import { __decorate } from "tslib";
import Renderer from '@/components/Builder/Renderer.vue';
import CdbModal from '@/components/CdbModal.vue';
import CustomSwitch from "@/components/CustomSwitch.vue";
import ICDModal from '@/components/ICD10/ICDModal.vue';
import Manipulation from '@/components/ManipulationModal.vue';
import Modal from "@/components/Modal.vue";
import Money from '@/components/Money.vue';
import OdbModal from '@/components/OdbModal.vue';
import SpecialtyNav from '@/components/SpecialtyNav.vue';
import SpecialtySelect from '@/components/SpecialtySelect.vue';
import ImageMap from '@/components/Teeth/Map.vue';
import ToothParts from "@/components/Tooth/Parts.vue";
import ToothPopover from '@/components/Tooth/ToothPopover.vue';
import ToothMap from '@/components/ToothMap.vue';
import TreatmentBrowser from '@/components/TreatmentBrowser.vue';
import TreatmentLoop from '@/components/TreatmentLoop.vue';
import ModalMixin from '@/mixins/modal-mixin';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { Component, Mixins, Prop } from "vue-property-decorator";
import draggable from 'vuedraggable';
import { mapActions, mapGetters, mapState } from 'vuex';
import { default as TreatmentComponent } from './Exam/Treatment.vue';
let NewExamModal = class NewExamModal extends Mixins(ModalMixin) {
    id;
    getCustomer;
    getCompanyFromStore;
    createExam;
    patchExam;
    exam = {
        complaints: {},
        objectively: [],
        diagnosis: [],
        cdb: [],
        odb: [],
        icd: [],
        diagnosisFinal: [],
        treatments: [],
        customerId: '',
        manipulations: [],
    };
    selected = {
        diagnosis: {},
        objectives: {},
        complaints: {},
        manipulations: {},
        map: [],
    };
    workOrderSelectedTeethInitial = [];
    kid = false;
    resultExams = [];
    get selectedToothMapTeeth() {
        return this.selected.map.filter(tooth => tooth != null);
    }
    get workOrderSelectedTeeth() {
        const teeth = new Set();
        this.workOrderSelectedTeethInitial.forEach(tooth => teeth.add(tooth));
        Object.values(this.selected.diagnosis).forEach(teethOfDiagnosis => {
            teethOfDiagnosis.forEach(tooth => teeth.add(tooth));
        });
        Object.values(this.selected.objectives).forEach(teethOfObjectives => {
            teethOfObjectives.forEach(tooth => teeth.add(tooth));
        });
        Object.values(this.selected.complaints).forEach(teethOfComplaints => {
            teethOfComplaints.forEach(tooth => teeth.add(tooth));
        });
        Object.values(this.selected.manipulations).forEach(teethOfManipulations => {
            teethOfManipulations.forEach(tooth => teeth.add(tooth));
        });
        const toothStates = {};
        Array.from(teeth).forEach((tooth) => {
            // @ts-ignore
            toothStates[tooth] = { state: ['predefined-active'] };
        });
        return toothStates;
    }
    ;
    get filteredCdb() {
        if (!this.selected.map.length)
            return this.exam.cdb;
        return this.filterComplaintsByTeeth(this.selected.map);
    }
    get filteredFinalCdb() {
        if (!this.selected.map.length)
            return this.exam.diagnosisFinal;
        return this.filterDiagnosisByTeeth(this.selected.map);
    }
    get filteredOdb() {
        if (!this.selected.map.length)
            return this.exam.odb;
        return this.filterObjectivesByTeeth(this.selected.map);
    }
    get filteredManipulations() {
        if (!this.selected.map.length)
            return this.exam.manipulations;
        return this.filterManipulationsByTeeth(this.selected.map);
    }
    get customer() {
        if (!this.exam)
            return null;
        return this.getCustomer(this.exam.customerId);
    }
    get modalTitle() {
        if (!this.customer)
            return this.$t('Loading...');
        return this.customer.first_name + ' ' + this.customer.last_name;
    }
    shown() {
        const { Treatment } = this.$FeathersVuex;
        let workOrder = Treatment.getFromStore('temp');
        const data = workOrder.data;
        this.kid = data.kid;
        this.parseResultExams(data.resultExams);
    }
    saveAction() {
        let successMessage;
        const activeTeeth = Object.keys(this.workOrderSelectedTeeth).map(value => {
            if (value == 'null')
                return null;
            else
                return parseInt(value);
        });
        const promises = Promise.all(activeTeeth.map(tooth => {
            const exam = this.collectExamForTooth(tooth);
            exam.reviewed = true;
            if (exam._id) {
                successMessage = this.$t('Exam has been saved').toString();
                return this.patchExam([exam._id, exam, {}]);
            }
            else {
                successMessage = this.$t('Exam has been created').toString();
                return this.createExam(exam);
            }
        }));
        promises.then(() => {
            this.$root.$emit('bv::hide::modal', this.id);
            this.$toasted.global.success({
                message: successMessage
            });
        });
        this.$root.$emit('bv::hide::modal', this.id);
    }
    removeDiangosisFinal(index) {
        this.$delete(this.selected.diagnosis, this.exam.diagnosisFinal[index]._id);
        this.exam.diagnosisFinal.splice(index, 1);
    }
    removeCdb(index) {
        const cdbId = this.exam.cdb[index]._id;
        if (!cdbId)
            throw new Error('CdbId is not set');
        this.$delete(this.selected.complaints, cdbId);
        this.exam.cdb.splice(index, 1);
    }
    removeOdb(index) {
        this.$delete(this.selected.objectives, this.exam.odb[index]._id);
        this.exam.odb.splice(index, 1);
    }
    useCdb(item) {
        const checkDuplicate = this.exam.cdb.find((cdb) => cdb._id === item._id);
        if (checkDuplicate) {
            this.$toasted.global.error({ message: this.$t('Already exists') });
            return;
        }
        this.exam.cdb.push(item);
        if (item && !this.selected.complaints[item._id]) {
            if (this.selected.map.length)
                this.$set(this.selected.complaints, item._id, this.selected.map);
            else
                this.$set(this.selected.complaints, item._id, [null]);
        }
    }
    useOdb(item) {
        const checkDuplicate = this.exam.odb.find((odb) => odb._id === item._id);
        if (checkDuplicate) {
            this.$toasted.global.error({ message: this.$t('Already exists') });
            return;
        }
        this.exam.odb.push(item);
        if (item && !this.selected.objectives[item._id]) {
            if (this.selected.map.length)
                this.$set(this.selected.objectives, item._id, this.selected.map);
            else
                this.$set(this.selected.objectives, item._id, [null]);
        }
    }
    useFinal(item) {
        const checkDuplicate = this.exam.diagnosisFinal.find((diagnosisFinal) => diagnosisFinal._id === item._id);
        if (checkDuplicate) {
            this.$toasted.global.error({ message: this.$t('Already exists') });
            return;
        }
        this.exam.diagnosisFinal.push(item);
        if (item && !this.selected.diagnosis[item._id]) {
            if (this.selected.map.length)
                this.$set(this.selected.diagnosis, item._id, this.selected.map);
            else
                this.$set(this.selected.diagnosis, item._id, [null]);
        }
    }
    useTreamentAction(item) {
        this.exam.treatments.unshift(item);
    }
    useManipulation(item) {
        item.treatmentId = this.resultExams[0].treatments[0]._id;
        if (!this.exam.manipulations) {
            this.$set(this.exam, 'manipulations', [item]);
        }
        else {
            const checkDuplicate = this.exam.manipulations.find((manipulation) => manipulation._id === item._id);
            if (checkDuplicate) {
                this.$toasted.global.error({ message: this.$t('Already exists') });
                return;
            }
            this.exam.manipulations.push(item);
            if (item && !this.selected.manipulations[item._id]) {
                if (this.selected.map.length)
                    this.$set(this.selected.manipulations, item._id, this.selected.map);
                else
                    this.$set(this.selected.manipulations, item._id, [null]);
            }
        }
    }
    removeManipulation(index) {
        this.$delete(this.selected.manipulations, this.exam.manipulations[index]._id);
        this.exam.manipulations.splice(index, 1);
    }
    collectExamForTooth(tooth) {
        const examForTooth = this.resultExams.find(exam => exam.tooth == tooth) || this.cloneExamForTooth(tooth);
        const manipulations = this.filterManipulationsByTeeth([tooth]);
        examForTooth.treatments = examForTooth.treatments.map((treatment) => {
            treatment.manipulations = manipulations.filter((manipulation) => manipulation.treatmentId === treatment._id);
            return treatment;
        });
        examForTooth.cdb = this.filterComplaintsByTeeth([tooth]);
        examForTooth.odb = this.filterObjectivesByTeeth([tooth]);
        examForTooth.diagnosisFinal = this.filterDiagnosisByTeeth([tooth]);
        return examForTooth;
    }
    cloneExamForTooth(tooth) {
        const newExam = this.$copy(this.resultExams[0]);
        // @ts-ignore
        delete newExam._id;
        const firstTreatment = newExam.treatments[0];
        firstTreatment.manipulations = [];
        newExam.odb = [];
        newExam.cdb = [];
        newExam.diagnosisFinal = [];
        newExam.treatments = [firstTreatment];
        newExam.tooth = tooth;
        return newExam;
    }
    filterManipulationsByTeeth(teeth) {
        const examManipulations = this.exam.manipulations;
        const filteredManipulationsIDs = [];
        const entries = Object.entries(this.selected.manipulations);
        entries.forEach(([manipulationId, manipulationTeeth]) => {
            const found = teeth.some(tooth => manipulationTeeth.includes(tooth));
            if (found)
                filteredManipulationsIDs.push(manipulationId);
        });
        return examManipulations.filter(item => filteredManipulationsIDs.includes(item._id));
    }
    filterComplaintsByTeeth(teeth) {
        const examCdb = this.exam.cdb;
        const filteredCdbIDs = [];
        const entries = Object.entries(this.selected.complaints);
        entries.forEach(([cdbId, cdbTeeth]) => {
            const found = teeth.some(tooth => cdbTeeth.includes(tooth));
            if (found)
                filteredCdbIDs.push(cdbId);
        });
        return examCdb.filter(item => filteredCdbIDs.includes(item._id));
    }
    filterObjectivesByTeeth(teeth) {
        const examOdb = this.exam.odb;
        const filteredOdbIDs = [];
        const entries = Object.entries(this.selected.objectives);
        entries.forEach(([OdbId, OdbTeeth]) => {
            const found = teeth.some(tooth => OdbTeeth.includes(tooth));
            if (found)
                filteredOdbIDs.push(OdbId);
        });
        return examOdb.filter(item => filteredOdbIDs.includes(item._id));
    }
    filterDiagnosisByTeeth(teeth) {
        const examFinalDiagnosis = this.exam.diagnosisFinal;
        const finalDiagnosisIds = [];
        const entries = Object.entries(this.selected.diagnosis);
        entries.forEach(([finalDiagnosisId, finalDiagnosisTeeth]) => {
            const found = teeth.some(tooth => finalDiagnosisTeeth.includes(tooth));
            if (found)
                finalDiagnosisIds.push(finalDiagnosisId);
        });
        return examFinalDiagnosis.filter(item => finalDiagnosisIds.includes(item._id));
    }
    parseResultExams(resultExams) {
        const set = this.$set;
        function addToothTo(category, id, tooth) {
            if (!category[id])
                set(category, id, [tooth]);
            else if (!category[id].includes(tooth))
                category[id].push(tooth);
        }
        ;
        resultExams.forEach(exam => {
            exam.cdb.forEach(cdb => {
                if (!this.exam.cdb.find((item) => item._id === cdb._id))
                    this.exam.cdb.push(cdb);
                addToothTo(this.selected.complaints, cdb._id, exam.tooth);
            });
            exam.odb.forEach(odb => {
                if (!Array.isArray(odb.value))
                    odb.value = [odb.value];
                if (!this.exam.odb.find((item) => item._id === odb._id))
                    this.exam.odb.push(odb);
                addToothTo(this.selected.objectives, odb._id, exam.tooth);
            });
            exam.diagnosisFinal.forEach(diagnosisFinal => {
                if (!this.exam.diagnosisFinal.find((item) => item._id === diagnosisFinal._id))
                    this.exam.diagnosisFinal.push(diagnosisFinal);
                addToothTo(this.selected.diagnosis, diagnosisFinal._id, exam.tooth);
            });
            const manipulationsWithTreatments = exam.treatments.reduce((acc, treatment) => {
                acc.push(...treatment.manipulations.map((manipulation) => ({
                    ...manipulation,
                    treatmentId: treatment._id,
                    label: manipulation.label + '*',
                })));
                return acc;
            }, []);
            manipulationsWithTreatments.forEach(manipulation => {
                if (!this.exam.manipulations.find((item) => item._id === manipulation._id))
                    this.exam.manipulations.push(manipulation);
                addToothTo(this.selected.manipulations, manipulation._id, exam.tooth);
            });
        });
        this.selected.map = resultExams.map(exam => exam.tooth);
        this.exam.customerId = resultExams[0].customerId;
        this.resultExams = resultExams;
    }
    hidden() {
        this.exam.cdb = [];
        this.exam.odb = [];
        this.exam.diagnosisFinal = [];
        this.exam.manipulations = [];
        this.exam.customerId = '';
        this.selected = {
            diagnosis: {},
            objectives: {},
            complaints: {},
            manipulations: {},
            map: [],
        };
    }
};
__decorate([
    Prop({ type: String, required: true })
], NewExamModal.prototype, "id", void 0);
NewExamModal = __decorate([
    Component({
        name: 'ExamModalNew',
        components: {
            draggable,
            Modal,
            Money,
            Renderer,
            OdbModal,
            ToothMap,
            CdbModal,
            ICDModal,
            TreatmentComponent,
            ToothParts,
            Treeselect,
            CustomSwitch,
            TreatmentLoop,
            SpecialtySelect,
            SpecialtyNav,
            TreatmentBrowser,
            ToothPopover,
            ImageMap,
            Manipulation
        },
        computed: {
            ...mapState('treatment', { areTreatmentsLoading: 'isFindPending' }),
            ...mapGetters('customers', { getCustomer: 'get' }),
            ...mapGetters('my-company', { getCompanyFromStore: 'get' }),
        },
        methods: {
            ...mapActions('exam', { createExam: 'create', patchExam: 'patch' }),
            ...mapActions('cdb', { findInCdb: 'find' }),
            ...mapActions('odb', { findInOdb: 'find' }),
        },
    })
], NewExamModal);
export default NewExamModal;
